<template>
	<div v-if="bubblesEnabled" class="floating-chat">
		<too-many-popups-dialog :room="popupRoomNotFitting" v-if="popupRoomNotFitting" @close="closePopup()" />
		<chat-bubbles class="chat-bubbles-container" id="chat__bubbles-container"/>
		<quick-chat-list class="quickchat-container" id="chat__bubbles-hook"/>
	</div>

</template>

<script>
import QuickChatList from '@/components/chat/QuickChatList';
import ChatBubbles from '@/components/chat/ChatBubbles';
import TooManyPopupsDialog from '@/components/chat/dialogs/TooManyPopupsDialog';
import { mapGetters } from 'vuex';
export default {
	components: {
		QuickChatList,
		'chat-bubbles': ChatBubbles,
		'too-many-popups-dialog': TooManyPopupsDialog
	},
	computed: {
		...mapGetters({
			bubblesEnabled: 'chat/bubblesEnabled',
			popupRoomNotFitting: 'chat/popupRoomNotFitting'
		})
	},
	methods: {
		closePopup() {
			this.$store.commit('chat/setPopupRoomNotFitting', null);
		}
	}
}
</script>

<style lang="scss">
	.floating-chat {
		position: fixed;
		bottom: 20px;
		right: 20px;
		z-index: 3;
	}
	.quickchat-container {
		position: fixed;
		right: 30px;
		bottom: 30px;
		z-index: 9;
	}
	.chat-bubbles-container {
		position: fixed;
		right: 30px;
		bottom: 86px;
		z-index: 10;
	}
</style>
